import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Pill from '@adsk/bim360-matrix-react-pill';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import {statusColorMapping} from '../../utils/checklist-helper';
import i18n from '../../utils/i18n';

const ChecklistEntityBlock = ({container, deeplinkUrl, instance, section, item}) => {
  const handleClick = e => {
    e.preventDefault();
    deeplinkUrl && window.open(deeplinkUrl);
  };
  const {title, status, instanceContainerId} = instance;
  const mainClassName = classNames('ChecklistEntityBlock__main', 'ChecklistEntityBlock__main--clickable');
  const textItemClass = 'ChecklistEntityBlock__text-item';
  const overflowTooltipItemClass = 'ChecklistEntityBlock__overflow-tooltip-item';
  const idFieldClasses = classNames('ChecklistEntityBlock__id', textItemClass);
  const titleClasses = classNames(overflowTooltipItemClass, textItemClass);
  const tooltipClassName = 'ChecklistEntityBlock__tooltip-container';

  return (
    <div className="ChecklistEntityBlock">
      <div className={mainClassName} onClick={handleClick}>
        <>
          <div className={textItemClass}>{i18n.t('new.checklist')}</div>
          <Pill color={statusColorMapping[status.name]} className={textItemClass} label={status.name} />
          <div className={idFieldClasses}>{`#${instanceContainerId}`}</div>
          <div className={titleClasses}>
            <OverflowTooltip
              container={container}
              autoTipOnEllipsis
              triggerTarget={Tooltip.TriggerTargets.TOOLTIP}
              theme={Tooltip.Themes.DARK}
              tooltipClassName={tooltipClassName}
            >
              {title}
            </OverflowTooltip>
          </div>
          <div> {'>'}</div>
          <div className={overflowTooltipItemClass}>
            <OverflowTooltip
              container={container}
              autoTipOnEllipsis
              content={section.title}
              triggerTarget={Tooltip.TriggerTargets.TOOLTIP}
              theme={Tooltip.Themes.DARK}
              tooltipClassName={tooltipClassName}
            >
              <span className={idFieldClasses}>{section.title}</span>
            </OverflowTooltip>
          </div>
          <div> {'>'}</div>
          <div className={overflowTooltipItemClass}>
            <OverflowTooltip
              container={container}
              autoTipOnEllipsis
              triggerTarget={Tooltip.TriggerTargets.TOOLTIP}
              theme={Tooltip.Themes.DARK}
              tooltipClassName={tooltipClassName}
            >
              {item.title}
            </OverflowTooltip>
          </div>
        </>
      </div>
    </div>
  );
};

ChecklistEntityBlock.displayName = 'ChecklistEntityBlock';

ChecklistEntityBlock.propTypes = {
  deeplinkUrl: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  instance: PropTypes.object.isRequired,
  container: PropTypes.object
};

export default ChecklistEntityBlock;
